import { ReactNode } from 'react';

import IconInfo from '@/assets/info-shape.svg?react';
import cn from '@/utils/cn';

const InstructionHint = ({
  title,
  className,
}: {
  title: string | ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'caption-large-semi group flex w-full items-center gap-1.5 rounded-md bg-gray-200 p-2',
        className
      )}
    >
      <IconInfo width={18} className="text-primary" />
      <p className="caption w-full text-start text-dark-gray-500">{title}</p>
    </div>
  );
};

export default InstructionHint;
